export var IdQuickSkip;
(function (IdQuickSkip) {
    IdQuickSkip["Construction"] = "Construction";
    IdQuickSkip["Production"] = "Production";
})(IdQuickSkip || (IdQuickSkip = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-skip-dialog/IdQuickSkip.ts
// module id = 297
// module chunks = 3